module.exports = __webpack_public_path__ + "static/media/techrobotix.01d196ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/techrobotix.png
// module id = 60
// module chunks = 0